import { upgradeSkillWithAoeRangeCard } from "@/character/skills/aoe-range";
import { upgradeSkillWithBuffDurationCard } from "@/character/skills/buff-duration";
import { upgradeSkillWithApCard } from "@/character/skills/buff-ap";
import { upgradeSkillWithCooldownCard } from "@/character/skills/cooldown-upgrade";
import type { SkillDefinition } from "@/character/skills/types";
import type { HomeEconomy } from "@/home/economy";

function withPlayerSkillApPool(economy: HomeEconomy): HomeEconomy {
  return { ...economy, skillApCards: economy.petSkillApCards };
}

function withPlayerSkillCooldownPool(economy: HomeEconomy): HomeEconomy {
  return { ...economy, skillCooldownCards: economy.petSkillCooldownCards };
}

function withPlayerSkillBuffDurationPool(economy: HomeEconomy): HomeEconomy {
  return { ...economy, skillBuffDurationCards: economy.petSkillBuffDurationCards };
}

function withPlayerSkillAoePool(economy: HomeEconomy): HomeEconomy {
  return { ...economy, skillAoeRangeCards: economy.petSkillAoeRangeCards };
}

function mapApResult(
  result: ReturnType<typeof upgradeSkillWithApCard>,
): ReturnType<typeof upgradeSkillWithApCard> {
  if (!result.ok) return result;
  return {
    ok: true as const,
    skill: result.skill,
    economy: { ...result.economy, petSkillApCards: result.economy.skillApCards },
  };
}

function mapCooldownResult(
  result: ReturnType<typeof upgradeSkillWithCooldownCard>,
) {
  if (!result.ok) return result;
  return {
    ok: true as const,
    skill: result.skill,
    economy: { ...result.economy, petSkillCooldownCards: result.economy.skillCooldownCards },
  };
}

function mapDurationResult(
  result: ReturnType<typeof upgradeSkillWithBuffDurationCard>,
) {
  if (!result.ok) return result;
  return {
    ok: true as const,
    skill: result.skill,
    economy: {
      ...result.economy,
      petSkillBuffDurationCards: result.economy.skillBuffDurationCards,
    },
  };
}

function mapAoeResult(
  result: ReturnType<typeof upgradeSkillWithAoeRangeCard>,
) {
  if (!result.ok) return result;
  return {
    ok: true as const,
    skill: result.skill,
    economy: { ...result.economy, petSkillAoeRangeCards: result.economy.skillAoeRangeCards },
  };
}

export function upgradePetSkillWithApCard(economy: HomeEconomy, skill: SkillDefinition) {
  return mapApResult(upgradeSkillWithApCard(withPlayerSkillApPool(economy), skill));
}

export function upgradePetSkillCooldownCard(economy: HomeEconomy, skill: SkillDefinition) {
  return mapCooldownResult(
    upgradeSkillWithCooldownCard(withPlayerSkillCooldownPool(economy), skill),
  );
}

export function upgradePetSkillBuffDurationCard(economy: HomeEconomy, skill: SkillDefinition) {
  return mapDurationResult(
    upgradeSkillWithBuffDurationCard(withPlayerSkillBuffDurationPool(economy), skill),
  );
}

export function upgradePetSkillAoeRangeCard(economy: HomeEconomy, skill: SkillDefinition) {
  return mapAoeResult(upgradeSkillWithAoeRangeCard(withPlayerSkillAoePool(economy), skill));
}
